import './App.css';
import { Routes, Route, useNavigate, Navigate, useLocation, } from 'react-router-dom';
import { useSelector } from "react-redux";
import { memo, useCallback, useEffect, useState } from "react";
import axios from "axios";
import KeyRegisterAllotInt from './allotment/Commodity_Allotment/KeyRegisterAllotInt';
import Home from './compents/Home'
import KeyRegCards_Interface from './allotment/keyregister/KeyRegCards_Interface'
import FPS_Stock from './fps/FPS_Stock';
import Bank_Error_Codes from './uidai/error_codes/Bank_Error_Codes'
import FPS_Trans_Int from './fps/FPS_Trans/FPS_Trans_Int';
import FPS_Status from './fps/FPS Status/FPS_Status';
import Version_abstract from './mis/Software Version/version_abstract'
import SchemeAllotAllInt from './allotment/SchemeAllotmentAll/SchemeAllotAllInt'
import Port_Abst from './mis/Intra Inter portability/Port_Abst'
import Login from './login/Login';
import AbstractFpsTransReport from './mis/FPS Detailed Transactions/AbstractFpsTransReport'
import Dist_RO_Int from './SideMenus/ROReceivedStatus/Dist_RO_Int';
import Nominee_Dist_Abstract from './SideMenus/Nominee Cards Abstract/Nominee_Dist_Abstract';
import FPS_Offline_Trans_Abstract from './SideMenus/OfflineFPSWiseTrans/FPS_Offline_Trans_Abstract'
import Ben_Ver_Abstract from './Beneficiary/Verification/Ben_Ver_Abstract'
import SRC_Trans_Int from './Beneficiary/Details/SRC_Trans_Int';
import AddMenusPageInt from './forms/Add Menus/AddMenusPageInt';
import AddNewScreens from './forms/Add Menus/AddNewScreens';
import Month_Trans_Interface from './SideMenus/Month Abstract/Month_Trans_Interface'
import FPSDayWiseInterface from './fps/FPS_Trans_datewis/FPSDayWiseInterface'
import AddMenusPage from './forms/Add Menus/AddMenusPage'
import Stock_Register_Int from './fps/Stock_Register_Int'
import FPS_Trans_Abstract from './fps/FPS_Trans/FPS_Trans_Abstract'
import UID_Auth_Interface from './uidai/UID Auth/UID_Auth_Interface'
import Auth_Suc_Int from './uidai/auth success abstract/Auth_Suc_Int'
import PMU from './Contact/PMU'
import Scheme_Allot_Int from './allotment/SchemeWiseAllotment/Scheme_Allot_Int'
import Auth_Fail_Int from './uidai/AuthFailureAbstract/Auth_Fail_Int'
import NonDrawnAbstract from './LoginData/Reports/non_drawal_cards/NonDrawnAbstract';
import ActiveInactiveAbstract from './mis/active inactive/ActiveInactiveAbstract'
import Scheme_Sale_Interface from './Sales/Scheme_Sale/Scheme_Sale_Interface'
import Stock_Interface from './Sales/Stock_Interface/Stock_Interface'
import NFSA_Sales_Int from './Sales/NFSA Sales/NFSA_Sales_Int'
import Sales_Int from './Sales/Sales/Sales_Int'
import Dist_Month_RO_Int from './ro/RoStatus/Dist_Month_RO_Int';
import Navbar from "./compents/Navbar";
import DkrEnable from './Adminstrator/DKR/Dkr_Enable';
import Portability_Interface from './SideMenus/Portability Details/Portability_Interface';
import Device_Addition_Int from './Adminstrator/Device_Addition_Int';
import Device_Addition from './LoginData/Reports/Device_Addition';
import FPS_Active_Int from './Adminstrator/FPS_Active_Int';
import AnnavitranSale from './Annavitran/sale/AnnavitranSale';
import AnnavitranTransInt from './Annavitran/AnnavitranTranscation/AnnavitranTransInt';
import AnnavitranState from './Annavitran/AnnavitranAbstract/AnnavitranState';
import Change_logMian from './mis/key Register Change stmt/ReportTable';
import Logout from "./logout/Logout";
import LoginSuccess from "./login/LoginSuccess";
import E403 from "./compents/error/E403";
import E404 from "./compents/error/E404";
import E500 from "./compents/error/E500";
import MyProvider from "./compents/MyProvider";
import Header from './compents/Header';
import Footer from './compents/Footer';
import PublicMenus from './compents/PublicMenus';
import { jwtDecode } from "jwt-decode";
import { CircularProgress } from '@mui/material';
import DeviceMenus from './Adminstrator/DeviceMenus';
import Device_Dealer_Interface from './Adminstrator/FpsDetails/Device_Dealer_Interface';
import RateMaster from './Adminstrator/RateMaster';
import FpsWiseWeighing from './Adminstrator/FpsWiseWeighing';
import CommWeighing from './Adminstrator/CommWeighing';
import Nominee_Cards_Abstract from './LoginData/Reports/nominee_cards_Abstract/Nominee_Cards_Abstract';
import Policy_Master_Interface from './Adminstrator/Policy_Master_Interface';
import Mobile_not_sedded_int from './LoginExcelDownLoads/Mobile_Not_seeded/Mobile_not_sedded_int';
import Ekyc_Abstract from './LoginExcelDownLoads/Ekyc_Abstract/ekyc_abstart_data_int';
import Non_Avail_cardss from './LoginExcelDownLoads/Non_Avail_cardss/Non_Avail_Cards';
import AuaAuthAnalysis from './LoginExcelDownLoads/AuaAuthAnalysis/AuaAuthAnalysis';
import FPSMenuDetails from './Adminstrator/FPSMenuDetails';
import EKYC_tobedone_int from './LoginExcelDownLoads/EkycToBeDone/EKYC_tobedone_int';
import ChangeStatmt_F_rpt from "./mis/key Register Change stmt/ChangeStatmt_F_rpt";
import RcmsChangeStatementReport from "./mis/RcmsChangeStmt/RcmsChangeStatementReport";
import FPSDeviceMapping from './Adminstrator/FPSDeviceMapping';
import UpdateFpsLatLong from './Adminstrator/UpdateFpsLatLong';
import Entitlement_Activate from "./Adminstrator/EntitlementGenertaion";
import Entitlement_Status from "./LoginData/Reports/EntitlementGenerationReport";
import Reset_Password from "./Adminstrator/Reset_Password";
import BannerForm from "./Adminstrator/BannerForm";
import Ekyc_Failed_DataList from './LoginData/Reports/Ekyc_Failed_DataList';
import Auth_Trans_Int from './LoginData/Reports/Auth_Trans_Int';
import Distribution_Extend_Interface from './Adminstrator/Distribution_Extend/Distribution_Extend_Interface';
import EKYC_Failed_Report from './LoginExcelDownLoads/Ekyc failed/EKYC_Failed_Report';
import Pmgkay_Int from './SideMenus/PMGKAY/Pmgkay_Int';
import AbstractTransReport from './SideMenus/Detailed Transactions/AbstractTransReport'
import OfflineUploadStatus from './LoginData/Reports/Offline_Upload_Status';
import Sales_NFSA_Non_NFSA_Int from './Sales/Sale_NFSA_Non_NFSA/Sales_NFSA_Non_NFSA_Int';
import DateWiseSaleAllotment from './Sales/DateWiseSaleAllotment/DateWiseSaleAllotment';
import CommoditySaleReport from './Sales/CommoditySaleReport/CommoditySaleReport';
import FPS_Per from './LoginData/Reports/FPS_Per';
import NomineeAddition from './Adminstrator/NomineeAddition.jsx';
import Impds_Interface from './SideMenus/Onorc/Impds_Interface';
import Portability_Sale from './Sales/Portability_Sale/Portability_Sale_Int';
import Portability_Drawl from './Sales/Portability_Drawl/Portability_Drawl_Int';
import Date_Wise_Sale_Dist from './Sales/DateWiseSaleDist';
import EkycVerification from './SideMenus/ekyc_Verification/EkycVerification';
import MonthWiseNFSACommision from './Commission/MonthWiseNFSACommision';
import EKYC_UID_Int from './Adminstrator/EKYC_UID_Int';
import MonthWiseStateCommission from './Commission/MonthWiseStateCommission';
import CommissionNfsaTdsPtax from './Commission/CommissionNfsaTdsPtax';
import Commmodityenabledisable from './Adminstrator/Commodityenabledisble';
import RefreshDistMonthWiseSales from './Adminstrator/RefreshMonthWiseSale';
import OBForm from './Adminstrator/OBForm/OBForm';
import OBReport from './Adminstrator/OBReport/OBReport_Int';
import ShopWiseNFSAStateSalesReport from './Sales/ShopWiseNFSAStateSalesReport/Shop_Wise_NFSA_State_Sales_Report';
import ChangePassword from './LoginData/ChangePassword';
import StockMovingInt from './LoginData/Reports/StockMovingInt';
import DFSO_FPS from './fps/FPS Details/DFSO_FPS';
import Scheme_Sale_All_Int from './Sales/Detailed Allotment and Sale/Scheme_Sale_All_Int';
import FPS_Login_Int from './fps/Activity/FPS_Login_Int';
import NoOfLogindaysInt from './fps/LoginDays/NoOfLogindaysInt';
import Truck_Ro_Recive_M_Y_Int from './ro/StockRecivedReport/Truck_Ro_Recive_M_Y_Int'
import SubsidyPolicyReport from './LoginData/FPS/SubisdyPolicyReport'
import SchemeWiseCommoditiesSubsidies from './LoginData/FPS/SchemeWiseCommoditiesSubsidies';
import Stock_Moving_Int from './LoginData/Reports/StockmovingReport/Stock_Moving_Int';
import Default_eKYC_int from './Adminstrator/Default_eKYC_int';
import MemberCount_Int from './LoginExcelDownLoads/MemberCount/MemberCount_Int';
import EkycReport from './SideMenus/ekyc_Verification/EkycReport';
import Date_wise_stock_details_int from './fps/DateWiseStockDetails/Date_wise_stock_details_int';
import CommissionStateTdsPtax from './Commission/CommissionStateTdsPtax'
import DistributionStatusReport from './SideMenus/per_Distribution_Status/DistributionStatusReport';
import CommissionSalesReport from './Commission/CommissionSalesReport';
import ChangeStatment_Report_rpt from './SideMenus/ChangeStatment_Report_rpt';
import BankApproval from './LoginData/BankDetailsApproval/BankApproval';
import CommissionStatusReport from './LoginData/BankDetailsApproval/CommissionStatusReport';
import BankApprovalStatusReport from './LoginData/BankDetailsApproval/BankApprovalStatusReport';
import BankUnfreeze from './LoginData/BankDetailsApproval/BankUnfreeze';
import Month_status from './Adminstrator/MonthStatus/Month_status';
import ShopWiseCardandSaleDetails from './fps/ShopWiseCardandSaleDetails/ShopWiseCardandSaleDetails';
import Sales_Data_Interface from './Sales/SaleSummary/Sales_Data_Interface';
import Revoke_insp from './Adminstrator/Revoke_insp.jsx';
import TotalSale from './Sales/TotalSale/PortabilitySale';
import FPSCommissionSummary from './Commission/FPSCommissionSummary';
import VerifyCommissionNFSAReport from './Commission/VerifyCommissionNFSAReport';
import VerifyCommissionStateReport from './Commission/VerifyCommissionStateReport';
import VerifyFPSWiseCommissionNFSAReport from './Commission/VerifyFPSWiseCommissionNFSAReport';
import VerifyFPSWiseCommissionStateReport from './Commission/VerifyFPSWiseCommissionStateReport';
import EkycUpdatereport from './SideMenus/ekycUpdateReport/EkycUpdateReport'
import ShopwisecardandsaledetailsExcelInt from './LoginExcelDownLoads/Shopwisecardsandsaledetailsexcel/ShopwisecardandsaledetailsExcelInt'
import RcmsMemberChangeStatementReport from './mis/RcmsMemberChangeStatement/RcmsMemberChangeStatementReport';
import MemberChangeStatementReport from './mis/MemberChangeStatementReport/MemberChangeStatementReport'
import FPS_Device_Mapping from './fps/FPSDeviceMapping'
import InspectorMaster from './Adminstrator/InspectorMaster';
import NoOfLogindaysRoleWiseExcel from './fps/LoginDays/NoOfLogindaysRoleWiseExcel';
import DistributionExtensionEndDateReport from './SideMenus/Distribution Extension End Date Report/DistExtensionReportInt';
import PortabilityFpsSearch from './SideMenus/PortabilityFpsSearch/PortabilityReport';
import ICDSSaleInt from './Adminstrator/ICDS/ICDSSaleInt'
import Port_Excel_Int from './LoginExcelDownLoads/FpsDetailsSalesPortability/Port_Excel_Int';
import SessionTimeout from "./login/SessionTimeout";
import EntitlementPage from './mis/RcmsEntitlemenet/EntitlementPage';
import ONRC_eKYC from './SideMenus/ONRC_eKYC/onrc';
import EkycAbstractReport from './LoginData/Reports/EkycAbstractReport/EKYCCardsUnitsInit';
import PortabilitySaleDetailsReport from './Sales/Portability Sale Details Report/PortabilityReport_Int'
import RegenerateCommissionNFSAState from './Commission/RegenerateCommissionNFSAState.jsx'
import BankReopen from './LoginData/BankDetailsApproval/BankReopen';
import Month_start from './mis/DKRReport/Month_start';
import Card_Nominee_Int from './Adminstrator/RCNomineeAddition/Card_Nominee_Int';
import DeviceInterface from './Adminstrator/Deviceinterface';
import DistrictWisePolicy from './mis/DistrictWisePolicy'
import DeviceDealerDetails from './LoginExcelDownLoads/DeviceDealerExceldownload';
import DelarInterface from './Adminstrator/DealerInterface/DeviceDealerInterface';
import NomineeDeleteInt from './Adminstrator/NomineeDelete/NomineeDeleteInt';
import StockMoveInt from './Adminstrator/StockMoveSchemeWise/StockMoveInt';
import OnrcAllotedIntDepot from './Sales/reonorcandregsalereport/OnrcAllotedIntDepot';
import OnrcAllotedIntAfso from './Sales/reonorcandregsalereport/OnrcAllotedIntAfso'
import Auth_Failures_Interface from './uidai/AuthFailure/Auth_Failures_Abstract';
import Unconsolidate_Consolidated_Cb from './Sales/CBreport/unconsolidatedConsolidateCb';
import Schedular from './Adminstrator/schedular/schedular';
import VRO_Details from './Adminstrator/Vro_Details_Update';
import StockMovingDistInt from './Adminstrator/StockMoveAll/StockMovingDistInt';
import FPS_Auth_Interface from './uidai/FPS_Auth_Interface/FPS_Auth_Interface';
import ShopwiseRegularImpdsSale from './LoginExcelDownLoads/ShopwiseRegularImpdsSale/Onrc_Alloted_Int_Afso';
import StockMoveSchemeWise from './Adminstrator/StockMoveSchemeWise/StockMoveSchemeWise';
import Ben_ver_list from './Adminstrator/BenfeciaryVerificationApproval/beneficairy';
import EstimatedCB from './LoginExcelDownLoads/EstimatedCB/EstimatedCB';
import Date_Wise_Ben_Ver_List from './mis/ModifyAadharDetails/Date_Wise_Ben_Ver_List';
import Excel_Download_Int from './LoginData/Reports/AllExcelDownload(FPSWISE)/ExcelDownloadPage';
import TransDataInt from './LoginData/Reports/TransDataReport/TransDataInt';
import DesignationMaster from './Adminstrator/DesignationMaster/DesignationMaster';
import SmsTranscationsInt  from './SideMenus/SmsTranscation/SmsTranscationsInt';

import Qcodesearch from './SideMenus/RcQuear/Qcodesearch';

const Layout = ({ children, logo, headerContent, footer, navbar }) => {
  const location = useLocation();
  const excludedPaths = [
    "/unauthorized-access",
    "/internal-server-issue",
    "/404",
    // "/login",
  ];
  const shouldShowLayout = !excludedPaths.includes(location.pathname);
  if (!shouldShowLayout) {
    return <>{children}</>;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header logo={logo} headerContent={headerContent} />
      <Navbar navbar={navbar} />
      <div style={{ flex: 1 }}>
        {children}
      </div>
      <Footer footer={footer} />
    </div>
  );
};

// Protected route component
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, navigate]);

  return isAuthenticated ? children : null;
};
const NavigationWrapper = memo(({ onFetchData }) => {
  const token = useSelector((state) => state.auth.token);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const navigate = useNavigate();

  const isCookiePresent = (name, value) => {
    const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
      const [key, val] = cookie.split("=");
      acc[key] = val;
      return acc;
    }, {});
    return cookies[name] === value;
  };


  useEffect(() => {
    const isAuthCookiePresent = isCookiePresent("isAuth", "true");

    if (isAuthenticated && !isAuthCookiePresent) {

      navigate("/logout");
    }
  }, [isAuthenticated, navigate]);

  // Data fetching effect
  useEffect(() => {
    let isSubscribed = true;

    const fetchData = async () => {
      if (isSubscribed) {
        await onFetchData(token);
      }
    };

    fetchData();

    return () => {
      isSubscribed = false;
    };
  }, [token, onFetchData]);


  // Cookie check effect
  useEffect(() => {


    if (!isCookiePresent("isAuth", "true")) {
      localStorage.clear();
    }
  }, []);


  return null;
});


function App() {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const [loading, setLoading] = useState(false);
  const [homeData, setHomeData] = useState({});
  const [menuData, setMenuData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_URL_SIDE}/demo/get_Public_Menus`)
      .then((response) => {
        setMenuData(response.data);
      })
      .catch((error) => {
        console.error('Error fetching menu data:', error);
      });
  }, []);


  const fetchData = useCallback(async (token) => {
    const controller = new AbortController();

    try {
      setLoading(true);
      const headers = {
        "Content-Type": "application/json",
        "X-React-Route": "/",
      };

      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/loadDetails`,
        {
          headers,
          withCredentials: true,
          signal: controller.signal,
        }
      );
      setHomeData(response.data);

      setLoading(false);
    } catch (error) {

      if (error.status === 401) {
        const userString = localStorage.getItem("person");

        if (userString) {
          navigate("/logout");
          return;
        }
      }
      if (!axios.isCancel(error)) {
        console.error("Error fetching data:", error);
      }
    } finally {
      setLoading(false);
    }

    return controller;
  }, []);

  return (
    <MyProvider>
      <NavigationWrapper onFetchData={fetchData} />
      {loading && <CircularProgress />}
      <Layout navbar={isAuthenticated ? homeData.loginMainMenu || [] : menuData}>
        <Routes>
          {/* Error Routes */}
          <Route path="/unauthorized-access" element={<E403 />} />
          <Route path="/internal-server-issue" element={<E500 />} />
          <Route path="*" element={<E404 />} />

          {/* Public Routes */}
          {!isAuthenticated && (
            <>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/logout" element={<Navigate to="/" replace />} />
              <Route path="/KeyReg_Allot_Interface" element={<KeyRegisterAllotInt heading="Commodity Allotment" />} />
              <Route path="/KeyRegCards_Interface" element={<KeyRegCards_Interface heading="Key Register Abstract" />} />
              <Route path="/FPS_Stock" element={<FPS_Stock heading="Stock Details" />} />
              <Route path="/uid_error" element={<Bank_Error_Codes heading="UID Error Description" />} />
              <Route path="/FPS_Trans_Int" element={<FPS_Trans_Int heading="FPS Wise Transactions" />} />
              <Route path="/FPS_Status" element={<FPS_Status heading="FPS Status" />} />
              <Route path="/Scheme_Allot_All_Int" element={<SchemeAllotAllInt heading="Detailed Allotment" />} />
              <Route path="/Scheme_Allot_Int" element={<Scheme_Allot_Int heading="Scheme Wise Allotment" />} />
              <Route path="/version_abstract" element={<Version_abstract heading="Version Abstract" />} />
              <Route path="/Port_Abst" element={<Port_Abst heading="Portability Cards" />} />
              <Route path="/AbstractFpsTransReport" element={<AbstractFpsTransReport heading="FPS Detailed Transactions" />} />
              <Route path="/FPSDayWiseInterface" element={<FPSDayWiseInterface heading="Date Wise Transaction Details" />} />
              <Route path="/Scheme_Sale_Interface" element={<Scheme_Sale_Interface heading="Scheme Wise Sale Abstract" />} />
              <Route path="/AnnavitranState" element={<AnnavitranState heading="Annavitran Abstract" />} />
              <Route path="/ChangeStatmt_F_rpt" element={<ChangeStatmt_F_rpt />} />
              <Route path="/RcmsChangeStatementReport" element={<RcmsChangeStatementReport />} />
              <Route path="/active_inactive" element={<ActiveInactiveAbstract heading="Active inactive" />} />
              <Route path="/AnnavitranSale" element={<AnnavitranSale heading="Annavitran Sale Abstract" />} />
              <Route path="/AnnavitranTransInt" element={<AnnavitranTransInt heading="Annavitran Transactions Abstract" />} />
              <Route path="/Change_logMian" element={<Change_logMian heading="MonthYearSelection" />} />
              <Route path="/Stock_Interface" element={<Stock_Interface heading="Stock Abstract" />} />
              <Route path="/Dist_Month_RO_Int" element={<Dist_Month_RO_Int heading="RO Received Status" />} />
              <Route path="/Truck_Ro_Recive_M_Y_Int" element={<Truck_Ro_Recive_M_Y_Int heading="Stock Received Report (Received Month Wise)" />} />
              <Route path="/Dist_RO_Int" element={<Dist_RO_Int heading="RO Received Status" />} />
              <Route path="/Nominee_Dist_Abstract" element={<Nominee_Dist_Abstract heading="Nominee Cards Abstract" />} />
              <Route path="/FPS_Offline_Trans_Abstract" element={<FPS_Offline_Trans_Abstract heading="Offline FPS Transactions" />} />
              <Route path="/Ben_Ver_Abstract" element={<Ben_Ver_Abstract heading="Beneficiary Verification Abstract" />} />
              <Route path="/SRC_Trans_Int" element={<SRC_Trans_Int heading="Beneficiary Details" />} />
              <Route path="/Month_Trans_Interface" element={<Month_Trans_Interface heading="Month Abstract Report" />} />
              <Route path="/Stock_Register_Int" element={<Stock_Register_Int heading="Stock Details" />} />
              <Route path="/FPS_Trans_Abstract" element={<FPS_Trans_Abstract heading="FPS Wise Transactions" />} />
              <Route path="/UID_Auth_Interface" element={<UID_Auth_Interface heading="UIDAI Authentication" />} />
              <Route path="/Auth_Suc_Int" element={<Auth_Suc_Int heading="Auth Success Abstract" />} />
              <Route path="/Auth_Fail_Int" element={<Auth_Fail_Int heading="Authentication Failure Abstract" />} />
              <Route path="/NFSA_Sales_Int" element={<NFSA_Sales_Int heading="NFSA Sale Abstract" />} />
              <Route path="/Sales_Int" element={<Sales_Int heading="Sales" />} />
              <Route path="/Sales_NFSA_Non_NFSA_Int" element={<Sales_NFSA_Non_NFSA_Int heading="Sales" />} />
              <Route path="/Date_Wise_Sale_Allotment_Int" element={<DateWiseSaleAllotment heading="Date Wise Sale Allotment" />} />
              <Route path="/MonthlySchemeWiseCommodity" element={<CommoditySaleReport heading="Commodity Sale Report" />} />
              <Route path="/Portability_Interface" element={<Portability_Interface heading="Portability Abstract" />} />
              <Route path="/AbstractTransReport" element={<AbstractTransReport heading="Detailed Transactions" />} />
              <Route path="/Pmgkay_Int" element={<Pmgkay_Int heading="PMGKAY- Rice Details" />} />
              <Route path="/PMU" element={<PMU heading="PMU" />} />
              <Route path="/dfso_fps_details" element={<DFSO_FPS />} />
              <Route path="/Scheme_Sale_All_Int" element={<Scheme_Sale_All_Int heading="Detailed Allotment & Sale" />} />
              <Route path="/FPS_Login_Int" element={<FPS_Login_Int heading="Add Pages" />} />
              <Route path="/EkycReport" element={<EkycReport />} />
              <Route path="/Date_wise_stock_details_int" element={<Date_wise_stock_details_int heading="Add Pages" />} />
              <Route path="/nominee_abstract" element={<Nominee_Cards_Abstract />} />
              <Route path="/impds_interface" element={<Impds_Interface />} />
              <Route path="/Portability_Sale" element={<Portability_Sale heading="Portability Sale" />} />
              <Route path="/Portability_Drawl" element={<Portability_Drawl />} />
              <Route path="/Date_Wise_Sale_Int" element={<Date_Wise_Sale_Dist />} />
              <Route path="/ChangeStatment_Report" element={<ChangeStatment_Report_rpt />} />
              <Route path="/per_status" element={<DistributionStatusReport />} />
              <Route path="/ShopWiseCardandSaleDetails" element={<ShopWiseCardandSaleDetails heading="Shop Wise Cards and Sale Details" />} />
              <Route path="/Sales_Data_Interface" element={<Sales_Data_Interface heading="Month Sales Data Summary" />} />
              <Route path="/NoOfLogindaysInt" element={<NoOfLogindaysInt />} />
              <Route path="/TotalSale" element={<TotalSale />} />
              <Route path="/EkycUpdatereport" element={<EkycUpdatereport />} />
              <Route path="/RCMSmemberchangestatement" element={<RcmsMemberChangeStatementReport />} />
              <Route path="/MemberChangeStatementReport" element={<MemberChangeStatementReport />} />
              <Route path="/FPS_Device_Mapping" element={<FPS_Device_Mapping />} />
              <Route path="/DistributionExtensionEndDateReport" element={<DistributionExtensionEndDateReport heading="Distribution Extension End Date Report" />} />
              <Route path="/PortabilityFpsSearch" element={<PortabilityFpsSearch />} />
              <Route path="/PortabilitySaleDetailsReport" element={<PortabilitySaleDetailsReport />} />
              <Route path="/ICDSSaleInt" element={<ICDSSaleInt />} />
              <Route path="/ONRC_eKYC" element={<ONRC_eKYC />} />
              <Route path="/month_start" element={<Month_start />} />
              <Route path="/DistrictWisePolicy" element={<DistrictWisePolicy />} />
              <Route path="/OnrcAllotedIntDepot" element={<OnrcAllotedIntDepot heading={"District / Depot Wise Sale"} sub="" />} />
              <Route path="/OnrcAllotedIntAfso" element={<OnrcAllotedIntAfso heading={"District / Mandal Wise  Sale"} sub="" />} />
              <Route path="/Auth_Failures_Interface" element={<Auth_Failures_Interface heading="Authentication Failure Abstract" />} />
              <Route path="/Unconsolidate_Consolidated_Cb" element={<Unconsolidate_Consolidated_Cb heading="Unconsolidated Cb & Consolidated Cb for Allotment" />} />               <Route path="/Date_Wise_Ben_Ver_List" element={<Date_Wise_Ben_Ver_List  />} />
              <Route path="/FPS_Auth_Interface" element={<FPS_Auth_Interface heading="FPS Authentications" />} />
              {/* <Route path="/Qcodesearch.jsp?rcno=2802768463" element={<RcSearch heading="RC Search" />} /> */}
              <Route path="/Qcodesearch" element={<Qcodesearch heading="RC Search" />} />
              <Route path="/SmsTranscationsInt" element={<SmsTranscationsInt />} />

            </> 
          )}
          {isAuthenticated && (
            <>
              <Route path="/" element={<Navigate to="/home" replace />} />
              <Route path="/home" element={<ProtectedRoute><LoginSuccess /></ProtectedRoute>} />
              <Route path="/logout" element={<ProtectedRoute><Logout /></ProtectedRoute>} />
              <Route path="/DataDownloadRequest" element={<ProtectedRoute><DkrEnable /></ProtectedRoute>} />
              <Route path="/MenuReport" element={<ProtectedRoute><DeviceMenus /></ProtectedRoute>} />
              <Route path="/Device_Dealer_Interface" element={<ProtectedRoute><Device_Dealer_Interface /></ProtectedRoute>} />
              <Route path="/Rate_Master_Interface" element={<ProtectedRoute><RateMaster /></ProtectedRoute>} />
              <Route path="/FPS_Weighing_Int" element={<ProtectedRoute><FpsWiseWeighing /></ProtectedRoute>} />
              <Route path="/Device_Addition_Int" element={<ProtectedRoute><Device_Addition_Int /></ProtectedRoute>} />
              <Route path="/device_details" element={<ProtectedRoute><Device_Addition /></ProtectedRoute>} />
              <Route path="/FPS_Active_Int" element={<ProtectedRoute><FPS_Active_Int /></ProtectedRoute>} />
              <Route path="/Excel_AUA_interface" element={<ProtectedRoute><AuaAuthAnalysis /></ProtectedRoute>} />
              <Route path="/Comm_Weighing_Enable" element={<ProtectedRoute><CommWeighing /></ProtectedRoute>} />
              <Route path="/nominee_abstract" element={<Nominee_Cards_Abstract />} />
              <Route path="/EntitlementGenertaion" element={<ProtectedRoute><Entitlement_Activate /></ProtectedRoute>} />
              <Route path="/Entitlement_Status" element={<ProtectedRoute><Entitlement_Status /></ProtectedRoute>} />
              <Route path="/Non_Drawl_Abst" element={<ProtectedRoute><NonDrawnAbstract /></ProtectedRoute>} />
              <Route path="/PolicyMaster_Interface" element={<ProtectedRoute><Policy_Master_Interface /></ProtectedRoute>} />
              <Route path="/Mobile_not_sedded_int" element={<ProtectedRoute><Mobile_not_sedded_int /></ProtectedRoute>} />
              <Route path="/ekyc_abstart_data_int" element={<ProtectedRoute><Ekyc_Abstract /></ProtectedRoute>} />
              <Route path="/Non_avail_cards" element={<ProtectedRoute><Non_Avail_cardss /></ProtectedRoute>} />
              <Route path="/MenuStatusReport" element={<ProtectedRoute><FPSMenuDetails /></ProtectedRoute>} />
              <Route path="/EKYC_tobedone_int" element={<ProtectedRoute><EKYC_tobedone_int /></ProtectedRoute>} />
              <Route path="/Reset_Password" element={<ProtectedRoute><Reset_Password /></ProtectedRoute>} />
              <Route path="/BannerForm" element={<ProtectedRoute><BannerForm /></ProtectedRoute>} />
              <Route path="/EkycFailedDataList" element={<ProtectedRoute><Ekyc_Failed_DataList /></ProtectedRoute>} />
              <Route path="/Distribution_Extend_Interface" element={<ProtectedRoute><Distribution_Extend_Interface /></ProtectedRoute>} />
              <Route path="/EKYC_Failed_Report" element={<ProtectedRoute><EKYC_Failed_Report /></ProtectedRoute>} />
              <Route path="/Auth_Trans_Int" element={<ProtectedRoute><Auth_Trans_Int /></ProtectedRoute>} />
              <Route path="/offlineUploadStatus" element={<ProtectedRoute><OfflineUploadStatus /></ProtectedRoute>} />
              <Route path="/FPS_Per" element={<ProtectedRoute><FPS_Per /></ProtectedRoute>} />
              <Route path="/Ben_Ver_Abstract" element={<Ben_Ver_Abstract heading="Beneficiary Verification Abstract" />} />
              <Route path="/Port_Abst" element={<Port_Abst heading="Portability Cards" />} />
              <Route path="/RC_Enable_Nominee" element={<ProtectedRoute> <NomineeAddition /> </ProtectedRoute>} />
              <Route path="/MonthWiseNFSACommision" element={<ProtectedRoute> <MonthWiseNFSACommision /></ProtectedRoute>} />
              <Route path="/eKYC_UID_Int" element={<ProtectedRoute> <EKYC_UID_Int /> </ProtectedRoute>} />
              <Route path="/MonthWiseStateCommision" element={<ProtectedRoute><MonthWiseStateCommission /></ProtectedRoute>} />
              <Route path="/CommissionNfsaTdsPtax" element={<ProtectedRoute><CommissionNfsaTdsPtax /></ProtectedRoute>} />
              <Route path="/CommissionStateTdsPtax" element={<ProtectedRoute><CommissionStateTdsPtax /></ProtectedRoute>} />
              <Route path="/OB_Update_Int" element={<ProtectedRoute><OBForm /></ProtectedRoute>} />
              <Route path="/OBReport" element={<ProtectedRoute> <OBReport heading="OB Details Report" /> </ProtectedRoute>} />
              <Route path="/CommodityEnableDisable" element={<ProtectedRoute> <Commmodityenabledisable /> </ProtectedRoute>} />
              <Route path="/RefreshDistMonthWiseSales" element={<ProtectedRoute> <RefreshDistMonthWiseSales /> </ProtectedRoute>} />
              <Route path="/ShopWiseNFSAStateSalesReport" element={<ProtectedRoute> <ShopWiseNFSAStateSalesReport heading="Shop Wise NFSA State Sales Report" /> </ProtectedRoute>} />
              <Route path="/ChangePassword" element={<ProtectedRoute> <ChangePassword /> </ProtectedRoute>} />
              <Route path="/StockMovingInt" element={<ProtectedRoute> <StockMovingInt /> </ProtectedRoute>} />
              <Route path="/Ekyc_verification" element={<ProtectedRoute><EkycVerification heading="Beneficiary e-KYC Verification Report" /></ProtectedRoute>} />
              <Route path="/SubsidyPolicyReport" element={<ProtectedRoute> <SubsidyPolicyReport /> </ProtectedRoute>} />
              <Route path="/SchemeWiseCommoditiesSubsidies" element={<ProtectedRoute> <SchemeWiseCommoditiesSubsidies /> </ProtectedRoute>} />
              <Route path="/Stock_Moving_Int" element={<ProtectedRoute> <Stock_Moving_Int /> </ProtectedRoute>} />
              <Route path="/Default_eKYC_int" element={<ProtectedRoute> <Default_eKYC_int /> </ProtectedRoute>} />
              <Route path="/MemberCount_Int" element={<ProtectedRoute> <MemberCount_Int heading="Units Wise Cards Details" /> </ProtectedRoute>} />
              <Route path="/CommissionSalesReport" element={<ProtectedRoute><CommissionSalesReport /></ProtectedRoute>} />
              <Route path="/BankApproval" element={<ProtectedRoute> <BankApproval /> </ProtectedRoute>} />
              <Route path="/CommissionStatusReport" element={<ProtectedRoute> <CommissionStatusReport /> </ProtectedRoute>} />
              <Route path="/BankApprovalStatus" element={<ProtectedRoute> <BankApprovalStatusReport /> </ProtectedRoute>} />
              <Route path="/BankUnfreeze" element={<ProtectedRoute> <BankUnfreeze /> </ProtectedRoute>} />
              <Route path="/Month_status" element={<ProtectedRoute> <Month_status /> </ProtectedRoute>} />
              <Route path="/Revoke_inspection" element={<ProtectedRoute> <Revoke_insp /> </ProtectedRoute>} />
              <Route path="/FPSCommissionSummary" element={<ProtectedRoute><FPSCommissionSummary /></ProtectedRoute>} />
              <Route path="/VerifyCommissionNFSAReport" element={<ProtectedRoute><VerifyCommissionNFSAReport /></ProtectedRoute>} />
              <Route path="/VerifyCommissionStateReport" element={<ProtectedRoute><VerifyCommissionStateReport /></ProtectedRoute>} />
              <Route path="/VerifyFPSWiseCommissionNFSAReport" element={<ProtectedRoute><VerifyFPSWiseCommissionNFSAReport /></ProtectedRoute>} />
              <Route path="/VerifyFPSWiseCommissionStateReport" element={<ProtectedRoute><VerifyFPSWiseCommissionStateReport /></ProtectedRoute>} />
              <Route path="/MonthlySchemeWiseCommodity" element={<ProtectedRoute> <CommoditySaleReport heading="Commodity Sale Report" /> </ProtectedRoute>} />
              <Route path="/Lat_Long_check_int" element={<ProtectedRoute><UpdateFpsLatLong /></ProtectedRoute>} />
              <Route path="/Device_Interface" element={<ProtectedRoute> <FPSDeviceMapping /> </ProtectedRoute>} />
              <Route path="/ShopwisecardandsaledetailsExcel" element={<ProtectedRoute> <ShopwisecardandsaledetailsExcelInt /> </ProtectedRoute>} />
              <Route path="/Inspection_Master_Entry" element={<ProtectedRoute><InspectorMaster /> </ProtectedRoute>} />
              <Route path="/TotalSale" element={<ProtectedRoute><TotalSale /> </ProtectedRoute>} />
              <Route path="/NoOfLogindaysIntExcel" element={<ProtectedRoute><NoOfLogindaysRoleWiseExcel /></ProtectedRoute>} />
              <Route path="/DistributionExtensionEndDateReport" element={<ProtectedRoute><DistributionExtensionEndDateReport /></ProtectedRoute>} />
              <Route path="/ICDSSaleInt" element={<ProtectedRoute><ICDSSaleInt /></ProtectedRoute>} />
              <Route path="/Port_Excel_Int" element={<ProtectedRoute><Port_Excel_Int /></ProtectedRoute>} />
              <Route path="/RcmsEntitlement" element={<ProtectedRoute><EntitlementPage /></ProtectedRoute>} />
              <Route path="/RcmsChangeStatementReport" element={<ProtectedRoute><RcmsChangeStatementReport /></ProtectedRoute>} />
              <Route path="/RCMSmemberchangestatement" element={<ProtectedRoute><RcmsMemberChangeStatementReport /></ProtectedRoute>} />
              <Route path="/EkycAbstractReport" element={<ProtectedRoute><EkycAbstractReport /></ProtectedRoute>} />
              <Route path="/PortabilitySaleDetailsReport" element={<ProtectedRoute><PortabilitySaleDetailsReport /></ProtectedRoute>} />
              <Route path="/RegenerateCommissionNFSAState" element={<ProtectedRoute><RegenerateCommissionNFSAState /></ProtectedRoute>} />
              <Route path="/BankReopen" element={<ProtectedRoute><BankReopen /></ProtectedRoute>} />
              <Route path="/Card_Nominee_Int" element={<ProtectedRoute><Card_Nominee_Int /></ProtectedRoute>} />
              <Route path="/DeviceInterface" element={<ProtectedRoute><DeviceInterface /></ProtectedRoute>} />
              <Route path="/DelarInterface" element={<ProtectedRoute><DelarInterface /></ProtectedRoute>} />
              <Route path="/DeviceDealerDetails" element={<ProtectedRoute><DeviceDealerDetails /></ProtectedRoute>} />
              <Route path="/NomineeDeleteInt" element={<ProtectedRoute><NomineeDeleteInt /></ProtectedRoute>} />
              <Route path="/StockMoveInt" element={<ProtectedRoute><StockMoveInt /></ProtectedRoute>} />
              <Route path="/VRO_Details" element={<ProtectedRoute><VRO_Details /></ProtectedRoute>} />
              <Route path="/Schedular" element={<ProtectedRoute><Schedular /></ProtectedRoute>} />
              <Route path="/StockMovingDistInt" element={<ProtectedRoute><StockMovingDistInt /></ProtectedRoute>} />
              <Route path="/ShopwiseRegularImpdsSale" element={<ProtectedRoute><ShopwiseRegularImpdsSale /></ProtectedRoute>} />
              <Route path="/StockMoveSchemeWise" element={<ProtectedRoute><StockMoveSchemeWise /></ProtectedRoute>} />
              <Route path="/ben_ver_list" element={<ProtectedRoute><Ben_ver_list /></ProtectedRoute>} />
              <Route path="/EstimatedCB" element={<ProtectedRoute><EstimatedCB /></ProtectedRoute>} />
              <Route path="/Excel_Download_Int" element={<ProtectedRoute><Excel_Download_Int /></ProtectedRoute>} />
              <Route path="/TransDataInt" element={<ProtectedRoute><TransDataInt /></ProtectedRoute>} />
              <Route path="/designationMasterAction" element={<ProtectedRoute><DesignationMaster /></ProtectedRoute>} />
            </>
          )}
        </Routes>
      </Layout>
      {isAuthenticated && <SessionTimeout />}

    </MyProvider>
  );
}

export default App;
